import { FollowThemeButton } from '@terminal/components/follow-theme-button/FollowThemeButton';
import { useCatalystInsightsList } from '@terminal/react-query-hooks/insights/useCatalystInsights';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useFlags } from '@terminal/stores/use-flags/useFlags';
import { CatalystInsightPill } from '@terminal/widgets/catalyst-insights-drawer/catalyst-insight-pill/CatalystInsightPill';
import clsx from 'clsx';
import { startOfDay, subDays } from 'date-fns';
import React, { useMemo } from 'react';

import { ThemeLogoIcon } from '../theme-logo-icon/ThemeLogoIcon';
import styles from './ThemeHeader.module.scss';

interface LegacyThemeHeaderProps {
  themeId: string;
  themeName: string;
  logo_url?: string;
  isCondensed?: boolean;
}

export const LegacyThemeHeader = ({
  themeId,
  themeName,
  logo_url,
  isCondensed = false,
}: LegacyThemeHeaderProps) => {
  const isFollowedThemesFlagEnabled = useFlags(state =>
    state.getFeatureFlagState('followed_themes')
  );
  const fromDate = useMemo(() => startOfDay(subDays(new Date(), 3)), []);
  const { data: catalystInsightsData } = useCatalystInsightsList({
    themes: [themeId],
    categories: ['market_wide'],
    from: fromDate.toISOString(),
    page: 1,
    page_size: 1,
  });

  return (
    <div className={styles.flexRow}>
      <div
        className={clsx(styles.logoAndTitle, {
          [styles.condensed]: isCondensed,
        })}
      >
        <ThemeLogoIcon
          logo_url={logo_url}
          name={themeName}
          key={themeName}
          isCondensed={isCondensed}
        />
        <span
          className={clsx(styles.titleText, {
            [styles.condensed]: isCondensed,
          })}
        >
          {themeName}
        </span>
      </div>
      <div className={styles.rightCluster}>
        {!!catalystInsightsData?.length && (
          <CatalystInsightPill
            insightId={catalystInsightsData[0].id}
            themeId={themeId}
            subCategory={catalystInsightsData[0].sub_category}
            isClickable
            source={POSTHOG_TRACKING_SOURCES.THEME_OVERVIEW}
            category={catalystInsightsData[0].category}
          />
        )}
        {isFollowedThemesFlagEnabled && <FollowThemeButton themeId={themeId} />}
      </div>
    </div>
  );
};
